import { render, staticRenderFns } from "./ReportMail.vue?vue&type=template&id=05c87fb5&scoped=true"
import script from "./ReportMail.vue?vue&type=script&lang=js"
export * from "./ReportMail.vue?vue&type=script&lang=js"
import style0 from "./ReportMail.vue?vue&type=style&index=0&id=05c87fb5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c87fb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05c87fb5')) {
      api.createRecord('05c87fb5', component.options)
    } else {
      api.reload('05c87fb5', component.options)
    }
    module.hot.accept("./ReportMail.vue?vue&type=template&id=05c87fb5&scoped=true", function () {
      api.rerender('05c87fb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/Modal/ReportMail.vue"
export default component.exports